import { render, staticRenderFns } from "./Server_error.vue?vue&type=template&id=30f21e5e&scoped=true&"
import script from "./Server_error.vue?vue&type=script&lang=js&"
export * from "./Server_error.vue?vue&type=script&lang=js&"
import style0 from "./Server_error.vue?vue&type=style&index=0&id=30f21e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f21e5e",
  null
  
)

export default component.exports